<template>
  <article class="accordion-block" :class="{'active': show}">
    <header v-on:click="toggle">
      <p style="font-size: 1.25rem">{{ content.region_name }}</p>
      <i class="accordion-block__details" :class="{'active' : show}"></i>
    </header>
    <transition name="accordion">
      <div class="accordion-block__body" v-show="show">
        <ul class="accordion-block__inner" v-for="(item, idx) in sortedDistricts" :key="`accordion-block__inner${idx}`">
          <li class="region-item">
            <span class="region-name">{{ item.name }}</span>

            <div class="region-right">
              <div class="region-links">
                <div>
                  <a v-if="item.tg_url" :href="item.tg_url" class="tg-link" target="_blank"><img src="@/assets/icons/soc_telegram.svg" alt=""></a>
                </div>
                <div>
                  <a v-if="item.max_url" :href="item.max_url" class="max-link" target="_blank"><img src="@/assets/icons/max.svg" alt=""></a>
                </div>
              </div>
            </div>

          </li>
        </ul>
      </div>
    </transition>
  </article>
</template>

<script>
export default {
  name: 'Accordion',
  props: {
    content: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      show: false
    }
  },
  computed: {
    sortedDistricts () {
      return [...(this.content.districts || [])].sort((a, b) =>
        (a.name || '').localeCompare(b.name || '', 'ru')
      )
    }
  },
  methods: {
    toggle () {
      this.show = !this.show
    }
  }
}
</script>

<style scoped lang="scss">
.region-name {
  font-size: 1.1rem;
}
.region-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 12px;
}

.region-right {
  display: flex;
  gap: 8px;
  width: 55%;
  min-width: 96px;
  @media screen and (max-width: 768px) {
    width: 20%;
  }
}

.region-links {
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: flex-start;
  gap: 25px;
  div {
    width: 37px;
  }
  a {
    text-decoration: underline;
    font-weight: 600;
    width: 37px;
    height: 28px;
    display: flex;
    align-items: flex-start;
    img {
      width: 37px;
    }
    &.max-link {
      margin-top: 4px;
      img {
        width: 24px;
      }
    }

  }
  a:hover {
    text-decoration: none;
  }
}

.icon-link {
  font-size: 11px;
  color: #6c757d;
  text-decoration: none;
}

.icon-link:hover {
  color: #2c3e50;
  text-decoration: underline;
}
  .accordion-block {
    padding: 1.25rem 1.875rem;
    border: 1px solid #E5E8EE;
    border-radius: 8px;
    margin-bottom: 1.2rem;
    font-size: .875rem;
    line-height: 1.57;

    &.active {
      box-shadow: 0 15px 25px rgba(189, 205, 221, 0.35);
    }

    header {
      color: #1F3245;
      font-weight: 600;
      cursor: pointer;
      display: flex;
      justify-content: space-between;
      align-items: center;

      & p {
        margin-right: 5rem;
      }

      & i {
        border: .1875rem solid #9D9D9D;
        border-width: 0 .1875rem .1875rem 0;
        border-radius: .0625rem;
        display: inline-block;
        padding: .1875rem;
        transform: rotate(45deg);
        -webkit-transform: rotate(45deg);
        margin-bottom: .0625rem;
      }

      .active {
        transform: rotate(-135deg);
        -webkit-transform: rotate(-135deg);
      }

    }

    &__body {
      margin-top: 1.875rem;
      padding-top: 1rem;
      border-top: 1px solid rgba(0, 0, 0, 0.1);

      :nth-child(n):not li {
        margin-bottom: 1.5rem;
      }

      :nth-child(n) {
        padding-top: 0;
        margin-bottom: .5rem;
      }

      :last-child {
        margin-bottom: 0;
      }
    }

    &__inner {
      color: rgba(23, 23, 23, 0.8);
      width: 85%;
      padding-top: 1.25rem;

      & ::v-deep {
        li {
          line-height: 1.57;
          color: #246CB7;
          cursor: pointer;
          list-style-type: disc;
          padding: 0;
          margin-left: 1rem;
          a {
            color: #246CB7;
          }
        }
      }
    }

  }

  @media screen and (max-width: 768px) {
    .accordion-block {
      &__inner {
        width: 96.78%;
      }
    }
  }

  @media screen and (max-width: 420px) {
    .accordion-block {
      padding: 1.25rem 1.38rem;

      &__inner {
        width: 92.78%;
      }

      header {
        p {
          margin-right: .125rem;
        }
      }
    }
  }
</style>
